import React, { useEffect, useState } from "react";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { GetLanguageString } from "../../helper/Components";
import DatePicker from "react-datepicker";
import { withRouter } from "react-router-dom";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import { addMember } from "../ApiMember";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";
import {
  CheckIsAdmin,
  CheckPermission,
  LoadingSpinner,
  convertUTCToLocalTime,
  isUrdu,
} from "../../../constants/const";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UpdateMemberSelectUnit from "./UpdateMemberSelectUnit";
import ChangeMemberUnit from "./ChangeMemberUnit";
import { isEqual } from "lodash";

const UpdateMemberUnit = ({
  history,
  tab9,
  memberId,
  addNewRafiq,
  setUpdatedDetails,
  memberTypeId,
  activeTab,
  setDiscard,
  setActiveTab,
  discard
}) => {
  const notify = (string) => toast.success(string);
  const { t } = useTranslation();
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [changeUnitModal, setChangeUnitModal] = useState(false);
  const [originalMemberUnit, setOriginalMemberUnit] = useState({
    date: new Date(),
    description: "",
    referenceNote: "",
  });
  const [comparisonValues, setComparisonValues] = useState({
    date: new Date(),
    description: "",
    referenceNote: "",
  });
  const [memberUnit, setMemberUnit] = useState({
    memberId: memberId,
    unit: { value: loggedInUnitId, label: "" },
    date: new Date(),
    description: "",
    referenceNote: "",
  });

  useEffect(() => {
    if (tab9 === "active") {
      addMember()
        .getMemberUnitDetail(memberId)
        .then((res) => {
          setMemberUnit({
            ...res.data,
            date: res.data.date
              ? new Date(convertUTCToLocalTime(res.data.date))
              : new Date(),
          });
          setOriginalMemberUnit({
            date: res.data.date
              ? new Date(convertUTCToLocalTime(res.data.date))
              : new Date(),
            description: res.data.description,
            referenceNote: res.data.referenceNote
          });
          setComparisonValues({
            date: res.data.date
            ? new Date(convertUTCToLocalTime(res.data.date))
            : new Date(),
          description: res.data.description,
          referenceNote: res.data.referenceNote
          });
        })
        .catch((err) => console.log(err));
    }
  }, [memberId, changeUnitModal, tab9]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMemberUnit({
      ...memberUnit,
      [name]: value,
    });
    setComparisonValues({
      ...comparisonValues,
      [name]: value,
    });
  };

  const handleInputChangeDate = (value) => {
    if (value !== null) {
      if (value <= new Date()) {
        // let date = new Date(value.setHours(value.getHours() + 5));
        setMemberUnit({
          ...memberUnit,
          date: value,
        });
        setComparisonValues({
          ...comparisonValues,
          date: value,
        })
      }
    }
  };

  const apiCall =() =>{
    setLoading(true);
    setButtonDisable(true);
    addMember()
      .addMemberUnit(memberUnit, addNewRafiq)
      .then((res) => {
        if (res.data === "") {
          swal({
            title:
              memberTypeId !== 11
                ? t("member__member_unit_added_success_message")
                : t("member__habib_unit_added_success_message"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "success",
            buttons: "OK",
          }).then((ok) => {
            setDiscard(!discard);
          });
          setUpdatedDetails((prevState) => !prevState);
          setLoading(false);
          setButtonDisable(false);
        } else notify(res.data);
        setLoading(false);
        setButtonDisable(false);
      })
      .catch((err) => {
        console.log(err);
        swal({
          title: err.response?.data,
          icon: "error",
          buttons: "OK",
        }).then((ok) => {
          setActiveTab("tab9");
        });
        setLoading(false);
        setButtonDisable(false);
      });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    apiCall();
    setComparisonValues("");
    setOriginalMemberUnit("");
  };
  const handleCancel = (e) => {
    const isMemberUnitChanged = isEqual(originalMemberUnit, memberUnit); // JSON.stringify(maritalStatus) === JSON.stringify maritalStatus);
    if (!isMemberUnitChanged) {
      swal({
        title: "Discard changes?",
        text: "Do you want to discard changes or save before canceling?",
        icon: "warning",
        buttons: ["Save Changes", "Discard"],
        closeOnClickOutside: false,
        dangerMode: true,
      }).then((willDiscard) => {
        if (willDiscard) {
          history.goBack(); // Process with cancel
        } else {
          handleSubmit(e); // Call the save function when the user chooses not to discard changes
        }
      });
    } else {
      history.goBack(); // No changes, directly go back
    }
}; 

useEffect(() => {
  // Check if the active tab has changed
  if(tab9 === "active"){
  if (activeTab && activeTab !== "tab9") {
    const isMemberUnitChanged = !isEqual(originalMemberUnit, comparisonValues); 

    if (isMemberUnitChanged) {
      swal({
        title: "Discard changes?",
        text: "Do you want to discard changes or save before canceling for Unit?",
        icon: "warning",
        buttons: ["Save Changes", "Discard"],
        closeOnClickOutside: false,
        dangerMode: true,
      }).then((willDiscard) => {
        if (willDiscard) {
            setDiscard(!discard);
            setOriginalMemberUnit("");
            setComparisonValues("");
        } else {
          apiCall();
        }
      });
    } else  {
      setDiscard(!discard);
    }
  }
}
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [activeTab]);

  return (
    <>
      {changeUnitModal ? (
        <ChangeMemberUnit
          setChangeUnitModal={setChangeUnitModal}
          memberId={memberId}
          previousUnitId={memberUnit.id}
          addNewRafiq={addNewRafiq}
          setUpdatedDetails={setUpdatedDetails}
        />
      ) : null}
      <div role="tabpanel" id="tab-9" className={"tab-pane " + tab9}>
        <div className="panel-body">
          <Form onSubmit={handleSubmit}>
            {!loading ? (
              <>
                <UpdateMemberSelectUnit
                  values={memberUnit}
                  setValues={setMemberUnit}
                  unitId={memberUnit.unit.value}
                  previousUnitId={memberUnit.id}
                />
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label className="col-form-label">
                        {<GetLanguageString props="member_joining_date" />}
                      </Label>
                      <DatePicker
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="dd/mm/yyyy"
                        className="form-control"
                        selected={memberUnit.date}
                        onChange={handleInputChangeDate}
                        dateFormat="dd/MM/yyyy"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label className="col-form-label">
                        {<GetLanguageString props="courses_description" />}
                      </Label>
                      <Input
                        className={isUrdu(memberUnit.description)? "ur" : ""}
                        type="text"
                        value={memberUnit.description}
                        name="description"
                        onChange={handleInputChange}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label className="col-form-label">
                        {<GetLanguageString props="member_reference_note" />}
                      </Label>
                      <Input
                        className={isUrdu(memberUnit.referenceNote)? "ur" : ""}
                        type="text"
                        value={memberUnit.referenceNote}
                        name="referenceNote"
                        onChange={handleInputChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </>
            ) : (
              LoadingSpinner()
            )}
            <Row>
              <Col md="8">
                <Button
                  color="primary"
                  onClick={() => setChangeUnitModal(true)}
                >
                  {
                    <GetLanguageString props="member_member_detail_chnage_unit" />
                  }
                </Button>
              </Col>

              <Col md="4">
                <div className={GetCustomStyles().btn_style}>
                  <Button color="white" onClick={handleCancel}>
                    {<GetLanguageString props="common_cancel" />}
                  </Button>
                  <Button
                    color="primary"
                    disabled={buttonDisable}
                    className="m-l-sm"
                    type="submit"
                  >
                    {<GetLanguageString props="common_save_changes" />}
                  </Button>
                </div>
              </Col>
            </Row>
            {CheckPermission("CanRequestMemberModificationUnit") &&
            !CheckIsAdmin() &&
            !addNewRafiq ? (
              <div>
                <h4 className="text-error">* Request Modification</h4>
              </div>
            ) : null}
          </Form>
        </div>
      </div>
    </>
  );
};

export default withRouter(UpdateMemberUnit);
